<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<li>
					<pools_radio_input v-on:validateField="validateField" v-bind:params="getParams('knowledge_ey')" v-bind:oldValue="oldValue['knowledge_ey']" v-bind:lang="lang"></pools_radio_input>
				</li>
				<li v-if="this.display.knowledge_ey == '2'">
					<select_checkbox_input v-on:validateField="validateExtraInput" v-bind:params="getParams('eventsEy')" v-bind:oldValue="oldValue['eventsEy']" v-bind:lang="lang"></select_checkbox_input>
				</li>
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import pools_radio_input from '@/components/candidate_forms/pools_radio_input.vue';
import select_checkbox_input from '@/components/candidate_forms/select_checkbox_input.vue';

import lib from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.display.knowledge_ey) return false;
	if(scope.display.knowledge_ey == "2" && !scope.answer['eventsEy']) return false; // Other
	return ['knowledge_ey'].every(e => scope.answer[e]);
}

function remove_ey_references(val){
	if(val != "other") delete this.answer['other_reference'];
}

export default {
	name: 'opinionTpl',
	data() {
		return {
			answer : {},
			oldValue : {},
			isActive : false,
			display: {
				knowledge_ey: false,
			},
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			}
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		pools_radio_input, select_checkbox_input
	},
	computed : {
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			let out = {};
			this.properties.fields.forEach( field => {
				if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
			});
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.display[name] = value;
			this.isActive = checkForm(this);
		},
		validateExtraInput : function(name, value) {
			const params = this.getParams(name);
			var answer = params && params.options && params.options.find(e => e.value == value); // Radio
			if(typeof answer == "undefined") answer = params && params.choices && params.choices.find(e => e.value == value); // Select_checkbox
			if(typeof this.display[name] != "undefined" && typeof value != "undefined") this.display[name] = answer && value;
			this.answer[name] = answer && value;
			this.isActive = checkForm(this);
		},
		getParams : function(name){
			return this.properties.fields.find(x => x.params && x.params.name == name).params;
		},
		scrollToThisInput : function(event) {
			return lib.scrollToElem(event.target);
		},
		getLabel : componentTools.getLabel
	},
	watch : {
		currentSession : {
			handler : function(val){
				let candidateTplRes = val.stepsResults && val.stepsResults[this.$options.name + '_' + this.templateIndex];
				if(!candidateTplRes){
					Object.keys(this.answer).forEach(k => this.$set(this.oldValue, k, null)); //cf vue reactivity for binded object properties
					this.answer = {};
				}
			},
			deep : true,
		},
		"display.ey_references" : remove_ey_references
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		if(oldRes) this.oldValue = oldRes;
	},
	mounted : componentTools.mounted
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ey/opinion.vue